import { Component } from '@angular/core';

@Component({
  selector: 'app-evaluation-sent',
  templateUrl: './evaluation-sent.component.html',
  styleUrls: ['./evaluation-sent.component.css']
})
export class EvaluationSentComponent {

}
